import { useMutation, useQueryClient } from 'react-query';

import type { CmsCollectionEntryModel } from '../../../../models/cms/collections/CmsCollectionEntryModel';
import type { CmsSaveMutationResponse } from '../../../../models/cms/CmsResponseModels';
import QUERYKEYS from '../../../../constants/queryKeys';
import { saveCollectionEntryContent } from '../../../../services/CmsCollectionService';

type CmsEntrySaveMutationResponse = CmsSaveMutationResponse<CmsCollectionEntryModel>;
export const useSaveCmsCollectionEntryContent = (): CmsEntrySaveMutationResponse => {
  const queryClient = useQueryClient();
  const { isError, isLoading, isSuccess, mutate } = useMutation(saveCollectionEntryContent, {
    onSuccess: (data) =>
      queryClient.invalidateQueries({
        predicate: (query) =>
          (query.queryKey[0] === QUERYKEYS.COLLECTION_ENTRY && query.queryKey[1] === data?.id) ||
          (query.queryKey[0] === QUERYKEYS.COLLECTION && query.queryKey[1] === data.collectionId),
      }),
  });

  return {
    save: mutate,
    isError,
    isLoading,
    isSuccess,
  };
};
